import { useState } from "react"
import { SearchSelect } from "../../shared/searchSelect"
import { SearchFiltersModal } from "../../shared/searchFiltersModal"
import stringHelpers from "../../../utilities/stringHelpers"

export const OrganisationsFiltersModal = ({
    showModal,
    handleClose,
    handleConfirm,
    initialCity,
    initialStatus,
    initialAppliedFilters,
    cityFilterList = []
}) => {
    const [city, setCity] = useState(initialCity)
    const [status, setStatus] = useState(initialStatus)
    const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

    const clearLocalFilters = () => {
        setCity(null)
        setStatus(null)
        setAppliedFilters(null)
    }

    return (
        <SearchFiltersModal
            title="Filter Results"
            handleClose={ handleClose }
            handleConfirm={ () => handleConfirm({ city, status, appliedFilters }) }
            showModal={ showModal }
            key="organisations-filters-modal"
            handleReset={ clearLocalFilters }
        >
            <div className="w-100">
                <div className="d-flex flex-column mb-2">
                    <label className="m-0 mr-2 mb-1 nowrap">City</label>
                    <SearchSelect
                        defaultLabel="All"
                        width="100%"
                        options={ [{ value: "", label: "All" }, ...cityFilterList.map(item => ({ value: item, label: item }))] }
                        onSelect={ value => {
                            if (!stringHelpers.isNullOrEmpty(value)) {
                                setCity(value)
                                setAppliedFilters(prevState => ({ ...prevState, "City": value }))
                            } else {
                                setCity(null)
                                setAppliedFilters(prevState => {
                                    const updatedFilters = { ...prevState }
                                    delete updatedFilters["City"]
                                    return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
                                })
                            }
                        } }
                        selected={ !stringHelpers.isNullOrEmpty(city) ? city : null }
                    />
                </div>

                <div className="d-flex flex-column mb-2">
                    <label htmlFor="organisations-status-selector" className="m-0 mr-2 mb-1 nowrap">Status</label>
                    <select
                        id="organisations-status-selector"
                        className="border rounded px-2 py-1 w-100"
                        value={ status === null ? "" : String(status) }
                        onChange={ e => {
                            const value = e.target.value === "" ? null : e.target.value === "true"
                            setStatus(value)
                            setAppliedFilters(prevState => {
                                const updatedFilters = { ...prevState }
                                if (value === null) {
                                    delete updatedFilters["Status"]
                                } else {
                                    updatedFilters["Status"] = value ? "Active" : "Deactivated"
                                }
                                return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
                            })
                        } }
                    >
                        <option value="">All</option>
                        <option value="true">Active</option>
                        <option value="false">Deactivated</option>
                    </select>
                </div>
            </div>
        </SearchFiltersModal>
    )
}
